import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { SimpleVariableCard } from '@/components/molecules';
import { SimpleFeatures, SimpleVariable} from "@/interfaces";
import { getIconFromName } from '@/utils/icons';

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    key: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

type SimpleTabPanelProps = {
  data: SimpleFeatures;
  selectedVariables: Array<SimpleVariable>;
  onSelect: (variable: SimpleVariable) => void;
};

export const SimpleTabPanel: React.FC<SimpleTabPanelProps>  = ({data, selectedVariables, onSelect}) => {

  const [tabId, setTabId] = useState(0);
  const [groupData, setGroupData] = useState<Array<any>>([]);

  useEffect(() => {
    setGroupData(data.groupData[tabId]);
  }, [data, tabId]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabId(newValue);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <Tabs
          orientation="vertical"
          value={tabId}
          onChange={handleTabChange}
        >
          {data.groups.map( (group, groupIdx) => (
            <Tab
              icon={getIconFromName(group, {fontSize: 'small'})}
              iconPosition="start"
              label={group}
              {...a11yProps(groupIdx)}
              sx={{ minHeight: '42px', height: '42px', justifyContent: 'flex-start', alignItems: 'flex-end'}}
            />
          ))}
        </Tabs>
      </Grid>
      <Grid item container xs={8} spacing={2}>
        <Stack spacing={2} mt={2} ml={2} sx={{ width: '100%' }}>
        {groupData && groupData.map((category, categoryIdx) => (
          //<Grid item xs={12} key={`category-data-${categoryIdx}`}>
            <SimpleVariableCard
              key={`category-data-${categoryIdx}`}
              title={category.name}
              variables={category.variables}
              selectedVariables={selectedVariables}
              onSelect={onSelect}
            />
          //</Grid>
        ))}
        </Stack>
      </Grid>
    </Grid>
  );
}
